import { render, staticRenderFns } from "./Metros_editor.vue?vue&type=template&id=0556832e"
import script from "./Metros_editor.vue?vue&type=script&lang=js"
export * from "./Metros_editor.vue?vue&type=script&lang=js"
import style0 from "./Metros_editor.vue?vue&type=style&index=0&id=0556832e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports